import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { closedAccountsFetchAction } from '../../../../store/fetchActions/userAccounts';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import { FirstFilterLine, SecondFilterLine } from '../../../../components/Filter/Filter.styles';
import TextField from '../../../../components/TextField';
import DateInput from '../../../../components/DateInput';
import Button from '../../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../../../components/SelectOptions';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import * as dayjs from 'dayjs';
import { useTheme } from 'styled-components';
import moment from 'moment';
import { pagesOptions } from '../../../../utils/constant';
import Loading from '../../../../components/Loading';

function UsuariosBloqueados({ value, index }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, closedAccountsFetchAction, value, index);

  useEffect(() => {
    dispatch(closedAccountsFetchAction(filter));
  }, [filter.PAGE]);

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    setFilterData(data);
  };

  const {
    closedAccountsData,
    paginationClosedAccounts,
    loadingClosedAccounts,
    errorClosedAccounts,
    errorMessageClosedAccounts,
  } = useSelector((state) => state.userAccounts);

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    {
      id: 'CPFCNPJ',
      name: 'CPF/CNPJ',
      align: 'left',
    },
    {
      id: 'nome',
      name: 'NOME',
      align: 'left',
    },
    {
      id: 'observação',
      name: 'OBSERVAÇÃO',
      align: 'left',
    },
  ];

  const body = closedAccountsData?.map((user) => {
    return {
      data: [
        {
          info: dayjs(user.DT_INSERT).format('DD/MM/YYYY HH:mm:ss') || '-----',
          align: 'center',
        },
        { info: user.CPFCNPJ, align: 'left' },
        { info: user.NOME, align: 'left' },
        { info: user.OBSERVACOES, align: 'left' },
      ],
    };
  });

  return (
    <div>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextField label="Nome ou CPF/CNPJ" name={'SEARCH'} width={'38.042vw'} control={control} />
            <DateInput
              label="Data Inicial"
              name={'DATA_INICIAL'}
              control={control}
              value={dateInicial}
              onChange={(newValue) =>
                newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
              }
            />
            <DateInput
              label="Data Final"
              name={'DATA_FINAL'}
              control={control}
              value={dateFinal}
              onChange={(newValue) =>
                newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
              }
            />

            <Button
              backgroundcolor={theme.colors.buttonSearch}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverbgcolor={theme.colors.buttonSearchHover}
              hovercolor={theme.colors.buttonSearchHoverText}
              mycolor={theme.colors.buttonSearchText}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>

          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions control={control} options={pagesOptions} name={'limit'} width={'5vw'} initialValue={10} />
            <h5>Total de resultados: {paginationClosedAccounts?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>

      {loadingClosedAccounts ? (
        <Loading />
      ) : (
        <Table
          loading={loadingClosedAccounts}
          error={errorClosedAccounts}
          hasPagination={true}
          filter={filter}
          pagination={paginationClosedAccounts}
          setFilter={setFilter}
          errorMessage={errorMessageClosedAccounts}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}
    </div>
  );
}

export default memo(UsuariosBloqueados);
